import fetch from '@/utils/fetch';

// 负责人 查询类型列表
export function getTrainTypeListByMangerUser() {

    return fetch({
        url: 'structure/throughTrain/getTrainTypeListByMangerUser',
        method: 'post',
    });

}

// 负责人查询记录列表
export function getTrainRecordListByMangerUser(args) {
    let params = new URLSearchParams();
    params.append('content', args.content);
    params.append('pageSize', args.pageSize);
    params.append('pageNo', args.pageNo);
    params.append('status', args.status);
    params.append('typeId', args.typeId);
    params.append('startDate', args.startDate);
    params.append('endDate', args.endDate);

    return fetch({
        url: 'structure/throughTrain/getTrainRecordListByMangerUser',
        method: 'get',
        params
    });

}

// 根据id查询留留记录
export function getTrainRecordById(args) {
    const params = new URLSearchParams();
    params.append('recordId', args.recordId);

    return fetch({
        url: 'structure/throughTrain/getTrainRecordById',
        method: 'get',
        params
    });
}

// 处理留言记录
export function batchTrainRecord(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/throughTrain/batchTrainRecord',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 处理留言记录
export function delTrainRecordById(args) {
    const params = new URLSearchParams();
    params.append('recordId', args.recordId);

    return fetch({
        url: 'structure/throughTrain/delTrainRecordById',
        method: 'post',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/affairs/affairs.js